import * as types from 'store/mutation-types'

export default {
  [types.SET_DRAFT_CHECKOUTS] (state, drafts) {
    state.draftCheckouts = drafts
  },
  [types.SET_PUBLISHED_CHECKOUTS] (state, published) {
    state.publishedCheckouts = published
  },
  [types.SET_TEMPLATES] (state, templates) {
    state.templates = templates
  },
  [types.SET_CHECKOUT_DATA] (state, checkoutData) {
    state.checkoutData = checkoutData
  },
  [types.CLEAR_CHECKOUT_DATA] (state) {
    state.checkoutData = null
  },
  [types.CHECKOUT_ACTIVE_TOGGLE] (state, { checkoutId, index, published }) {
    state.checkoutList[index].isPublished = !state.checkoutList[index].isPublished
  },
  [types.CHECKOUT_ACTIVE_DISABLE] (state, { checkoutId, index }) {
    state.checkoutList[index].isPublished = false
  },
  [types.SET_CHECKOUT_ACTIVE_EDIT] (state, checkoutData) {
    state.checkoutActiveEdit = JSON.parse(JSON.stringify(checkoutData))
  },
  [types.CLEAR_CHECKOUT_ACTIVE_EDIT] (state, checkoutData) {
    state.checkoutActiveEdit = {}
  },
  [types.SET_CHECKOUT_ACTIVE_EDIT_OFFERS] (state, offerList) {
    state.checkoutActiveEdit.activeOffersList = offerList
  },
  [types.CHANGE_MANAGING_PUBLICATION] (state, status) {
    state.managingPublication = status
  },
  [types.SET_NEED_FEEDBACK] (state, need = true) {
    state.needFeedback = need
  },
  [types.SET_HAS_FEEDBACK] (state, has = true) {
    state.hasFeedback = has
  },
  [types.SET_CURRENT_PRODUCT_HOTLINKS] (state, hotlinks) {
    state.currentProductHotlinks = hotlinks
  }
}
